import * as React from "react";
import { useEffect } from "react";
import { SingleToast } from "@skbkontur/react-ui";
import { AttachInfo } from "Common/CandyApiClient/Types/Attachments/Attacments";

import { ConvertationStatus } from "../Convertation/Types";

import { ErrorMessage } from "./ViewFileConversion.styles";

interface ViewFileConversionProps {
    convertationStatus?: ConvertationStatus;
    attachment?: AttachInfo;
}

export const ViewFileConversion = (props: ViewFileConversionProps) => {
    const { convertationStatus, attachment } = props;

    useEffect(() => {
        if (convertationStatus === ConvertationStatus.Success && attachment?.meta?.isConverted === true) {
            SingleToast.push("Файл сконвертирован в PDF согласно требованиям формата.");
        }
    }, [convertationStatus, attachment?.meta?.isConverted]);

    if (convertationStatus === ConvertationStatus.Failed) {
        return <ErrorMessage>Не удалось завершить конвертацию.</ErrorMessage>;
    }

    return null;
};
